import 'swag-client-common/utils/change-public-path/change-public-path';
import 'core-js';
import { hot } from 'react-hot-loader/root';
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import '@ezetech/swag-space-x/dist/styles/index.css';
import '@ezetech/swag-space-x/dist/styles/divider.css';
import '@ezetech/swag-space-x/dist/styles/dialog.css';
import '@ezetech/swag-space-x/dist/styles/input-wrapper.css';
import '@ezetech/swag-space-x/dist/styles/swag-button.css';
import '@ezetech/swag-space-x/dist/styles/text-field.css';
import '@ezetech/swag-space-x/dist/styles/typography.css';
import '@ezetech/swag-space-x/dist/styles/announcement-bar.css';
import '@ezetech/swag-space-x/dist/styles/checkbox.css';
import '@ezetech/swag-space-x/dist/styles/radio-group.css';
import '@ezetech/swag-space-x/dist/styles/radio.css';
import '@ezetech/swag-space-x/dist/styles/tooltip.css';
import '@ezetech/swag-space-x/dist/styles/input.css';
import { customerStore } from '../redux/swag.store';
import SuspenseFallback from '../components/suspense-fallback';
import { customerRoutes } from './swag.router';
const AppRoot = hot(() => customerRoutes(customerStore, customerStore.dispatch));
const app = /*#__PURE__*/React.createElement(Provider, {
  store: customerStore
}, /*#__PURE__*/React.createElement(React.Suspense, {
  fallback: /*#__PURE__*/React.createElement(SuspenseFallback, null)
}, /*#__PURE__*/React.createElement(AppRoot, null)));
ReactDom.render(app, document.getElementById('root'));
if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept();
  }
}